export const UiConfig = Object.freeze({
    infiniteScrollThreshold: 150,
    rollDiceDuration: 750,
});